import { combineEpics } from "redux-observable";
import { loadExperimentationGroupsEpicReducer, loadRootExperimentationGroupEpicReducer, createAnalysisRuleEpicReducer, loadAssignmentUnitsEpicReducer, loadAnalysisTemplatesEpicReducer } from "../components/AnalysisConfigCreateContainer/Create.epics.js";
const rootEpic = combineEpics(
  loadExperimentationGroupsEpicReducer.epic,
  loadRootExperimentationGroupEpicReducer.epic,
  createAnalysisRuleEpicReducer.epic,
  loadAssignmentUnitsEpicReducer.epic,
  loadAnalysisTemplatesEpicReducer.epic
);
export {
  rootEpic as default,
  rootEpic
};
//# sourceMappingURL=AnalysisConfigCreate.epics.js.map
